import { apiClient } from '../client';

export type ShopifyPlaybookKey =
  | 'order_confirmed'
  | 'order_placed'
  | 'order_cancelled'
  | 'order_shipped'
  | 'order_out_for_delivery'
  | 'order_delivered'
  | 'abandoned_cart'
  | 'new_customer'
  | 'refund_created';

export type ShopifyPlaybookStatus = 'NOT_CONFIGURED' | 'ACTIVE' | 'PAUSED' | 'DRAFT';

export interface ShopifyPlaybookCatalogEntry {
  key: ShopifyPlaybookKey;
  title: string;
  description: string;
  icon: string;
  triggerType: string;
  triggerNodeType: string;
}

export interface ShopifyPlaybookStatusEntry {
  key: ShopifyPlaybookKey;
  title: string;
  description: string;
  icon: string;
  triggerType: string;
  status: ShopifyPlaybookStatus;
  flowId: string | null;
  templateId: string | null;
  updatedAt: string | null;
}

export interface ShopifyPlaybookDetail {
  key: ShopifyPlaybookKey;
  status: ShopifyPlaybookStatus;
  flowId?: string;
  templateId: string | null;
  variables: Record<string, string>;
}

export const shopifyPlaybooksApi = {
  async getCatalog() {
    return apiClient.get<ShopifyPlaybookCatalogEntry[]>('/shopify/playbooks/catalog');
  },

  async list(businessAccountId: string) {
    return apiClient.get<ShopifyPlaybookStatusEntry[]>('/shopify/playbooks', {
      params: { businessAccountId },
    });
  },

  async getDetail(key: ShopifyPlaybookKey, businessAccountId: string) {
    return apiClient.get<ShopifyPlaybookDetail>(`/shopify/playbooks/${key}`, {
      params: { businessAccountId },
    });
  },

  async enable(
    key: ShopifyPlaybookKey,
    body: {
      templateId: string;
      variables?: Record<string, string>;
      businessAccountId: string;
    }
  ) {
    return apiClient.post(`/shopify/playbooks/${key}/enable`, body);
  },

  async update(
    key: ShopifyPlaybookKey,
    body: {
      templateId?: string;
      variables?: Record<string, string>;
      status?: 'ACTIVE' | 'PAUSED';
      businessAccountId: string;
    }
  ) {
    return apiClient.patch(`/shopify/playbooks/${key}`, body);
  },

  async remove(key: ShopifyPlaybookKey, businessAccountId: string) {
    const qs = new URLSearchParams({ businessAccountId }).toString();
    return apiClient.delete(`/shopify/playbooks/${key}?${qs}`);
  },
};
